import React, { useContext, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { toggleCollapsedNav } from 'actions/App';
import UserControls from 'components/UserControls';
import { appInIframe } from '../../../util/appUtils';
import { ReactComponent as Logo } from '../../../assets/images/kealogo-text-bg.svg';
import OperationStatusPills from '../../../features/operation-supervisor/OperationStatusPills';
import Menu from './Menu';
import { MenuDataContext } from '../MenuDataProvider';
import { useLocalizedMessage } from '../../../util/useLocalizedMessage';

const NAV_OVERRIDE_ID = 'kea-nav-overrides';

export const NAV_OVERRIDE_CSS = `
  .nav-shell {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 64px;
    background-color: #fff;
    border-bottom: 1px solid #ddeae5;
    box-shadow: 0 6px 20px rgba(30, 34, 72, 0.06);
    position: relative;
    z-index: 10;
  }
  .nav-shell-inner {
    width: 100%;
    max-width: 1400px;
    height: 64px;
    padding: 10px 16px;
    background-color: #fff;
    box-sizing: border-box;
  }
  .nav-shell-inner .app-main-header,
  .nav-shell-inner .app-main-menu,
  .nav-shell-inner .app-main-header.app-bar,
  .nav-shell-inner .app-main-header .app-toolbar,
  .nav-shell-inner .app-main-menu .menu-nav,
  .nav-shell-inner .app-main-menu .navbar,
  .nav-shell-inner .app-main-menu .navbar-nav,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav.navbar-nav-mega {
    background-color: #fff !important;
    color: #566078 !important;
    box-shadow: none !important;
    min-height: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item {
    padding: 0 !important;
    height: 44px;
    display: flex;
    align-items: stretch;
    position: relative;
    background: transparent !important;
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item:hover,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item:focus,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item.active {
    background: transparent !important;
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item > a,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item > span,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item .nav-link,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item .prepend-icon {
    min-height: 44px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    border: 1px solid transparent;
    border-radius: 10px;
    box-sizing: border-box;
    color: #566078 !important;
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
  }
  .nav-shell-inner .app-main-header .app-toolbar {
    min-height: auto !important;
    height: auto !important;
    max-height: none !important;
    justify-content: space-between;
    width: 100%;
  }
  .nav-shell-inner .app-main-menu .nav-item {
    color: #566078;
  }
  .nav-shell-inner .app-main-menu .nav-item > a,
  .nav-shell-inner .app-main-menu .nav-item > span,
  .nav-shell-inner .app-main-menu .nav-item .nav-link,
  .nav-shell-inner .app-main-menu .nav-item .prepend-icon,
  .nav-shell-inner .app-main-menu .sub-menu li a {
    transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;
  }
  .nav-shell-inner .app-main-menu .nav-item > a,
  .nav-shell-inner .app-main-menu .nav-item > span,
  .nav-shell-inner .app-main-menu .nav-item .prepend-icon,
  .nav-shell-inner .app-main-menu .nav-item .nav-link,
  .nav-shell-inner .app-main-menu .nav-item .nav-text {
    color: inherit !important;
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item:hover > a,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item:hover > span,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item:hover > .nav-link,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item:hover > .prepend-icon,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item > a:hover,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item > span:hover,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item .nav-link:hover,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item .prepend-icon:hover {
    background-color: #f3fbf8 !important;
    border-color: #e1efe9 !important;
    color: #226b51 !important;
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav li.nav-item.active > a,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav li.nav-item.active > span.nav-link,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item .nav-link.active,
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item .prepend-icon.active {
    background-color: var(--kea-color-primary-soft) !important;
    border-color: var(--kea-color-primary-border) !important;
    color: #226b51 !important;
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item.disabled {
    opacity: 0.52;
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item.disabled > span {
    cursor: not-allowed;
  }
  .nav-shell-inner .nav-dropdown-chevron {
    width: 15px;
    height: 15px;
    margin-left: 7px;
    flex: 0 0 15px;
    display: block;
    overflow: visible;
    transition: transform 0.16s ease;
  }
  .nav-shell-inner .nav-dropdown-chevron path {
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item.menu-open .nav-dropdown-chevron {
    transform: rotate(180deg);
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .sub-menu {
    top: calc(100% + 6px);
    left: 0;
    min-width: 224px;
    margin: 0;
    padding: 8px;
    background: #fff !important;
    border: 1px solid #ddeae5;
    border-radius: 8px;
    box-shadow: 0 16px 36px rgba(30, 34, 72, 0.15);
    opacity: 0 !important;
    visibility: hidden !important;
    pointer-events: none;
    transform: translateY(-2px);
    transition: opacity 0.14s ease, visibility 0.14s ease, transform 0.14s ease;
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .sub-menu::before {
    content: '';
    position: absolute;
    top: -7px;
    left: 0;
    width: 100%;
    height: 7px;
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item.menu-open > .sub-menu {
    opacity: 1 !important;
    visibility: visible !important;
    pointer-events: auto;
    transform: translateY(0);
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .sub-menu li {
    margin: 0;
    padding: 0;
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .sub-menu li + li {
    margin-top: 2px;
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .sub-menu li a {
    display: flex;
    align-items: center;
    min-height: 38px;
    padding: 8px 11px;
    border: 1px solid transparent;
    border-radius: 6px;
    color: #3f4963 !important;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.35;
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .sub-menu li a:hover {
    background-color: #f3fbf8 !important;
    border-color: #e1efe9 !important;
    color: #226b51 !important;
  }
  .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .sub-menu li a.active {
    background-color: var(--kea-color-primary-soft) !important;
    border-color: var(--kea-color-primary-border) !important;
    color: #226b51 !important;
    font-weight: 600;
  }
  .nav-shell-inner .nav-actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .nav-shell-inner .nav-left {
    display: flex;
    align-items: center;
  }
  .nav-shell-inner .app-logo,
  .nav-shell-inner .app-logo:hover,
  .nav-shell-inner .app-logo:focus,
  .nav-shell-inner .app-logo:active,
  .nav-shell-inner .app-logo * {
    background-color: transparent !important;
    color: inherit !important;
  }
  .nav-shell-inner .app-logo .kealabs-logo {
    display: block;
    width: 64px;
    height: 44px;
  }
  @media (max-width: 1080px) {
    .nav-shell-inner {
      padding-right: 12px;
      padding-left: 12px;
    }
    .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav {
      gap: 4px;
    }
    .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item > a,
    .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item > span,
    .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item .nav-link,
    .nav-shell-inner .app-main-menu.app-top-nav .navbar-nav .nav-item .prepend-icon {
      padding-right: 12px;
      padding-left: 12px;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .nav-shell-inner .app-main-menu *,
    .nav-shell-inner .nav-dropdown-chevron {
      transition: none !important;
    }
  }
`;

/**
 * Compute the link target for the logo/home button.
 * In embedded mode: canonical /app/:shopId/home (never /signin).
 * Outside embedded: root /.
 */
export const getLogoTarget = (pathname) => {
  const match = pathname.match(/^\/app\/([^/]+)/);
  const shopId = match ? match[1] : null;
  if (appInIframe()) {
    return shopId ? `/app/${shopId}/home` : '/embedded/app';
  }
  return '/';
};

const InsideNavHeader = ({ navCollapsed, location }) => {
  const dispatch = useDispatch();
  const t = useLocalizedMessage();

  useEffect(() => {
    let el = document.getElementById(NAV_OVERRIDE_ID);
    if (!el) {
      el = document.createElement('style');
      el.id = NAV_OVERRIDE_ID;
      el.appendChild(document.createTextNode(NAV_OVERRIDE_CSS));
      document.head.appendChild(el);
    }
    return () => {
      const node = document.getElementById(NAV_OVERRIDE_ID);
      if (node) node.remove();
    };
  }, []);

  const onToggleCollapsedNav = () => {
    const val = !navCollapsed;
    dispatch(toggleCollapsedNav(val));
  };

  const menuData = useContext(MenuDataContext);
  if (!menuData) return (<div />);
  const logoTarget = getLogoTarget(location.pathname);
  const appMatch = location.pathname.match(/^\/app\/([^/]+)/);
  const routeShopId = appMatch ? appMatch[1] : null;
  const showOperationPills = appInIframe() && !!routeShopId;

  return (
    <>
      <div className="nav-shell">
        <div className="nav-shell-inner">
          <AppBar className="app-main-header">
            <Toolbar className="app-toolbar" disableGutters={false}>
              <button type="button" className="d-block d-md-none pointer mr-3" onClick={onToggleCollapsedNav} aria-label={t('navigation.toggle')}>
                <span className="jr-menu-icon">
                  <span className="menu-icon" />
                </span>
              </button>
              <div className="nav-left">
                <Link className="app-logo mr-2 d-none d-sm-block" to={logoTarget}>
                  <Logo className="kealabs-logo" role="img" aria-label="Kea Labs" />
                </Link>
                <Menu data={menuData} />
              </div>
              <div className="nav-actions">
                {showOperationPills && (
                  <OperationStatusPills shopId={routeShopId} />
                )}
                <UserControls showLogout={false} />
              </div>
            </Toolbar>
          </AppBar>
        </div>
      </div>
    </>
  );
};

export default withRouter(InsideNavHeader);
